module.exports = __webpack_public_path__ + "static/media/educsss.2d8fcfa5.webp";